//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbFacet from './rb-facet.vue'
import RbColorFacet from './rb-color-facet.vue'
import RbToggleFacet from './rb-toggle-facet.vue'
import RbRangeFacet from './rb-range-facet.vue'
import { DATA_MNT_FILTER_NAMES } from '@/scripts/constants/plp'

export default {
  name: 'rb-facet-values',
  components: {
    RbFacet,
    RbColorFacet,
    RbToggleFacet,
    RbRangeFacet,
  },
  props: {
    facet: {
      type: Object,
      required: true,
    },
    minPriceRange: {
      type: Number,
      default: 0,
    },
    maxPriceRange: {
      type: Number,
      default: 0,
    },
    resetFacetPrice: {
      type: Boolean,
      default: false,
    },
    appliedFacets: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dataMntName() {
      if (!this.facet?.key || !DATA_MNT_FILTER_NAMES[this.facet.key]) {
        return ''
      }

      return `data-mnt-filter-${DATA_MNT_FILTER_NAMES[this.facet.key]}`
    },
  },
  methods: {
    getFacetComponent(type) {
      switch (type) {
        case 'standard':
          return 'RbFacet'
        case 'color':
          return 'RbColorFacet'
        case 'toggle':
          return 'RbToggleFacet'
        case 'range':
          return 'RbRangeFacet'
        default:
          return 'div'
      }
    },
  },
}
